import React, { Component } from "react";
import { Icon, notification } from 'antd';
import moment from 'moment';
import lockr from 'lockr';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { pick } from 'lodash';
import { Link } from 'react-router-dom';

import * as userActions from '../../actions/user'
import { LandingStyle } from "../Home/HomeStyles";
import { Row, Col } from '../../components';
import Youtube from '../../components/Youtube/Youtube';

import Login from "../Login/Login";

import HeaderBanner from '../../assets/img/landingsPage_Eleven/HeaderBanner.jpg';
import Prizes from '../../assets/img/landingsPage_Eleven/prizes.png';
import Scherm1 from '../../assets/img/landingsPage_Eleven/scherm1.jpg';
import Scherm2 from '../../assets/img/landingsPage_Eleven/scherm2.jpg';
import Scherm3 from '../../assets/img/landingsPage_Eleven/scherm3.jpg';

import { StoreState, UserState, ApplicationState } from '../../types';

interface Props {
	location: any,
	onSetProfileData: any
	fetchUserTeams: any;
	user: UserState;
	match: any;
	application: ApplicationState;
	t: any;
}

export interface State {

}

class Eleven extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {

		};
	};

	componentDidMount() {
		lockr.set('eleven', 1);

		const ReactPixel = require('react-facebook-pixel');
		ReactPixel.default.init('189588915101780');
		ReactPixel.default.pageView();
	}

	login = () => {
		// const environment = 'https://login.staging.proleague.be';
		// const id = 'tcm1fsNxI0SrEUHH8k6U9g';
		const environment = 'https://login.proleague.be';
		const id = '9voI581yRUC9Oa7pNlvvyQ';
		const redirect = this.props.application.competition.redirectURL;

		const vrtLoginURL = `${environment}?tenantid=${id}&returnvisitorurl=${redirect}&successredirecturl=${redirect}&mandatory=true&`;

		window.location.replace(vrtLoginURL);
	};

	render() {
		const { user, t } = this.props;

		return (
			<LandingStyle>
				<Row style={{ margin: '0', padding: '0', width: '100% !important' }}>
					<Col xs={24}>
						<img src={HeaderBanner} onClick={this.login} style={{cursor: 'pointer', width: '100%'}} />
					</Col>
				</Row>

				<Row>
					<Col md={8}>
						<Row className="onboarding">
							<Col md={24}><img src={Scherm1} /></Col>
							<Col md={24}>
								<h4 className="title">{this.props.t('homePage.onboardingStep1Title')}</h4>
								{this.props.t('homePage.onboardingStep1copy')}
							</Col>
						</Row>
					</Col>
					<Col md={8}>
						<Row className="onboarding">
							<Col md={24}><img src={Scherm2} /></Col>
							<Col md={24}>
								<h4 className="title">{this.props.t('homePage.onboardingStep2Title')}</h4>
								{this.props.t('homePage.onboardingStep2copy')}
							</Col>
						</Row>
					</Col>
					<Col md={8}>
						<Row className="onboarding">
							<Col md={24}><img src={Scherm3} /></Col>
							<Col md={24}>
								<h4 className="title">{this.props.t('homePage.onboardingStep3Title')}</h4>
								{this.props.t('homePage.onboardingStep3copy')}
							</Col>
						</Row>
					</Col>
				</Row>
			
				<Row className="onboarding">
					<Col md={12}>
						<Row className="onboarding">
							<Col md={24}>
								<h4 className="title">{this.props.t('eleven.winTitle')}</h4>
								{this.props.t('eleven.winBody')}
							</Col>
							<Col md={24}>
								<p style={{ width: '300px', margin: "20px auto"}}>
									<a onClick={this.login} className="c-button c-button--md c-button--beta c-button--block" rel="noopener noreferrer">{this.props.t('eleven.winButton')}</a>
								</p>
							</Col>
						</Row>
					</Col>
					<Col md={12}><img src={Prizes} style={{ width: '100%', height: 'auto', backgroundSize: 'contain' }} /></Col>
				</Row>
			
				<Row className="onboarding">
					<Col md={12}>
						<Youtube embedId={this.props.t('eleven.videoString')} />
					</Col>
					<Col md={12}>
						<Row className="onboarding">
							<Col md={24}>
								<h4 className="title">{this.props.t('eleven.videoTitle')}</h4>
								{this.props.t('eleven.videoBody')}
							</Col>
						</Row>
					</Col>
				</Row>
			</LandingStyle>
		);
	}
}

export const mapDispatchToProps = {
	onSetProfileData: (data: any) => (dispatch: any) => dispatch(userActions.setProfileData(data)),
	fetchUserTeams: userActions.fetchTeams
};

export function mapStateToProps({ user, application, matches }: StoreState.All) {
	return {
		user,
		application
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Eleven);